module.exports = "/_next/static/images/visa-9ba247bb6c981689fe4afc8edcda0f58.svg";